export const addPrefixPhone = (phone) => {
  //let phone = { ...pPhone };
  if (phone.length === 10) {
    phone = `+91${phone}`;
  }
  return phone;  
};

export const removePrefixPhone = (pPhone) => {  
  //let phone = { ...pPhone };
  if (pPhone.length === 13) {
    pPhone = pPhone.replace('+91', '');
  }
  return pPhone;
};
